import { useSearchParams } from 'react-router-dom';

export const SEPERATOR = ',';
const action_param_key = 'action';
const options_param_keys = ['id'];

export type ActionOptionType = {
  id?: string;
};

export default function useAction<T extends string>() {
  const [searchParams, setSearchParams] = useSearchParams();
  let actions = searchParams.get(action_param_key)?.split(SEPERATOR) || [];
  let options = options_param_keys.reduce<Record<string, string>>(
    (acc, key) => {
      const value = searchParams.get(key);
      if (value) acc[key] = value;
      return acc;
    },
    {}
  );

  const deleteAllSearchParams = () => {
    // remove the action key from query params
    searchParams.has(action_param_key) && searchParams.delete(action_param_key);
    // remove the options keys from query params

    options_param_keys.forEach(
      (key) => searchParams.has(key) && searchParams.delete(key)
    );
  };

  const setAction = (
    _action: T | false,
    trigger = true,
    _options?: ActionOptionType
  ) => {
    if (_action === false) {
      deleteAllSearchParams();
    } else {
      // add or remove a particular key
      if (trigger === true) {
        // add a key
        actions = [...new Set([...actions, _action])];
        options = { ...options, ..._options };
      } else {
        // remove a key
        actions = actions.filter((_act) => _act !== _action);
      }

      if (actions.length) {
        searchParams.set(action_param_key, actions.join(SEPERATOR));

        Object.entries(options).forEach(([key, value]) =>
          searchParams.set(key, value)
        );
      } else {
        deleteAllSearchParams();
      }
    }

    setSearchParams(searchParams);
  };

  return [actions, setAction, options] as const;
}
